// ** React Imports
import React, {Fragment, useEffect, useRef, useState} from 'react'
import '@styles/react/libs/tables/react-dataTable-component.scss'
import {
    Button,
    Card,
    CardBody,
    CardHeader,
    CardText,
    CardTitle,
    Col,
    FormFeedback,
    Input,
    Label,
    Row, Spinner
} from "reactstrap";
import {useNavigate, useParams} from "react-router-dom";

import {L10n, registerLicense} from '@syncfusion/ej2-base'
registerLicense(process.env.REACT_APP_DOCUMENT_EDITOR_KEY)

import { DocumentEditorContainerComponent, Toolbar } from '@syncfusion/ej2-react-documenteditor';
import {es} from "./locale";
import axios from "axios";
import {Controller, useForm} from "react-hook-form";
import toast from "react-hot-toast";
DocumentEditorContainerComponent.Inject(Toolbar);

L10n.load({
    es
});

const EditTemplate = () => {

    const inputEl = useRef();
    const params = useParams();
    const navigate = useNavigate();
    const [templateDetail, setTemplateDetail] = useState({});
    const [loading, setLoading] = useState(false);
    const [loadingMsg, setLoadingMsg] = useState('Cargando plantilla...');
    const defaultValues = {
        name: ''
    };
    const {
        control,
        setError,
        handleSubmit,
        setValue,
        formState: { errors }
    } = useForm({defaultValues});

    useEffect(() => {
        getTemplate();
    }, []);


    const onSubmit = async (data) => {
        if (Object.values(data).every(field => field.length > 0)) {

            try {
                setLoadingMsg('Actualizando plantilla...');
                setLoading(true);
                await axios.post(`${process.env.REACT_APP_API_URL}/templates/${params.templateId}`,{
                    name: data.name,
                    urlDocument: templateDetail.urlDocument
                });
                toast.success('Plantilla actualizada con exito!')
                setLoading(false);
                setTimeout(() => navigate('/templates'), 1000);
            } catch (e) {
                setLoading(false);
                toast.error(`Ha ocurrido un error: ${e.message}`);
            }

        } else {
            for (const key in data) {
                if (data[key].length === 0) {
                    setError(key, {
                        type: 'manual'
                    })
                }
            }
        }
    }

    const getTemplate = async () => {
        try {
            setLoading(true);
            const response =  await axios.get(`${process.env.REACT_APP_API_URL}/templates/${params.templateId}`);
            setTemplateDetail(response.data);
            setValue('name', response.data.name);
            const url =  response.data.urlDocument;
            await axios.post(`${process.env.REACT_APP_API_NODE_URL}/template/download`, {
                url
            });
            setLoading(false);
            // inputEl.open(document.data.data)
        } catch (e) {
            setLoading(false);
            toast.error(`Ha ocurrido un error: ${e.message}`);
        }

    }

    const getTemplates = () => {
        const sfdt = `{
    "sections": [
        {
            "blocks": [
                {
                    "inlines": [
                        {
                            "characterFormat": {
                                "bold": true,
                                "italic": true
                            },
                            "text": "Hello World"
                        }
                    ]
                }
            ],
            "headersFooters": {
            }
        }
    ]
}`;

        inputEl.open(sfdt)
        console.log(inputEl.current)
    }


    return (<Fragment>
            <Card>
                <CardHeader>
                    <CardTitle>Editar Plantilla</CardTitle>
                </CardHeader>
                <CardBody>
                    {loading ? <Row>
                    <div className='col-12 px-2 py-4 text-center'>
                        <Spinner size='lg'/>
                        <CardText className={'py-1 fs-5'}>{loadingMsg}</CardText>
                    </div>
                </Row> : <Row tag='form' className='gy-1 pt-75' onSubmit={handleSubmit(onSubmit)}>
                        <Col md={6} xs={12}>
                            <Label className='form-label' for='name'>
                                Nombre plantilla*
                            </Label>
                            <Controller
                                control={control}
                                name='name'
                                render={({ field }) => {
                                    return (
                                        <Input
                                            {...field}
                                            id='name'
                                            placeholder='John Cardenas'
                                            value={field.value}
                                            invalid={errors.name && true}
                                        />
                                    )
                                }}
                            />
                            {errors.name && <FormFeedback>Por favor ingrese un nombre valido</FormFeedback>}
                        </Col>



                        <Col md={12} xs={12}>
                            <small className={'text-secondary'}>
                                Campos obligatorios (*)
                            </small>
                        </Col>

                        <Col md={12} xs={12}>
                            <hr/>
                        </Col>

                        <Col md={12} xs={12}>
                            <Row>
                                <Col md={6} xs={12} className=''>
                                    <CardText>Edita el contenido de la plantilla.</CardText>
                                </Col>

                                <Col md={6} xs={12} className='pb-2'>
                                    <Button type='submit' className='float-end' color='primary'>
                                        Guardar
                                    </Button>
                                </Col>

                                <Col md={12} xs={12} className=''>
                                    <DocumentEditorContainerComponent id="container" style={{ height: '800px' }}
                                                                      ref={inputEl}
                                                                      height={'800'} locale={'es'}
                                                                      serviceUrl="https://ej2services.syncfusion.com/production/web-services/api/documenteditor/" enableToolbar={true}/>
                                </Col>
                            </Row>

                        </Col>



                        <Col md={12} xs={12}>
                            <hr/>
                        </Col>

                    </Row>}
                </CardBody>
                {/*<Button type='button' color='danger' onClick={getTemplates} size={'sm'}
                        className={'me-75'}>
                    Rechazar
                </Button>*/}
            </Card>
        </Fragment>
    )
}

export default EditTemplate
